import { render } from "./logoutBtn.vue?vue&type=template&id=5c84b8c1"
import script from "./logoutBtn.vue?vue&type=script&lang=js"
export * from "./logoutBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__